export default "__VITE_ASSET__6a468e0d__"